function LastPost( {data, Link}){
 return(
    <>
    <section className="latest-posts">
        <h3>Latest Posts</h3>
        <div className="posts-grid">
        {data?.latest_blogs?.data.map((post, index) => (
            <div className="post-card pointer-crusser" key={index}>
            <Link to={`/blog/${post?.action_url}`}>
                <img src={post.media} alt={post.name} />
                <div className="post-info">
                <div className="post-meta">
                    <span className="post-date">
                    Posted on{" "}
                    {new Date(post.created_at).toLocaleDateString(
                        "en-GB",
                        {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        }
                    )}
                    </span>
                    <span>{post?.readTime}</span>
                </div>
                <h4>{post.name}</h4>
                </div>
            </Link>
            </div>
        ))}
        </div>
    </section>
    </>

    )
}
export default LastPost